import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import { getPager } from "../../helpers/common";
import {
    API_SEARCH_ONLY_LISTING,
} from "../../services/ApisRoutes";
import { post } from "../../services/HttpClient";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import GeniusImage from "../../assets/images/genius-bird.png";
import { setLastSearch } from "./loginconfigSlice";
import { setDesireCountry, setPriceRangeValue } from "./searchFilterSlice";
import AppConfig from "../../helpers/config";

export const getHotels = createAsyncThunk(
    "hotels/getHotels",
    async ({ params, T, dispatch, navigate, shouldAddToSearchHistory = false, geniusDestinationObject = null, handleSearchTypeRef = null }) => {
        return new Promise((resolve, reject) => {
            post(API_SEARCH_ONLY_LISTING, params)
                .then(async (response) => {
                     

                    let _offers = response?.data?.offers?.map((hotel) => {
                        if (hotel !== undefined) {
                            return {
                                ...hotel?.newPackagedOffer?.hotelOfferSingleRoom,
                                price: {
                                    totalPrice: hotel?.price?.packageTotalPrice?.value,
                                    currency: hotel?.price?.packageTotalPrice?.currency,
                                },
                                perPersonPrice: {
                                    totalPrice: hotel?.price?.averageCostPerPerson?.value,
                                    currency: hotel?.price?.averageCostPerPerson?.currency,
                                },
                                address:
                                    hotel?.newPackagedOffer?.hotelOfferSingleRoom?.location
                                        ?.address?.city +
                                    ", " +
                                    hotel?.newPackagedOffer?.hotelOfferSingleRoom?.location
                                        ?.address?.country,
                                objHotel: hotel,
                                guidForBooking: response?.data?.correlationId
                                    ? response.data.correlationId
                                    : params.GUID,
                            };
                        }
                    });

                    if (
                        params.SearchType !== 'GPT' &&
                        response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code !== "204.02" &&
                        response?.data?.warnings[0]?.code !== "204.03"
                    ) {
                        toast.info(response?.data?.warnings[0].description);
                    }


                    if (
                        response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code === "204.02" &&
                        response?.data?.responseType === 'Memory'
                    ) {
                        dispatch(setActivityIndicator(false));

                        const result = await Swal.fire({
                            title: T("Common:No_Matches_Under_Budget"),
                            // text: T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                            text: response?.data?.warnings[0]?.description || T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                            iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                            showCancelButton: true,
                            confirmButtonText: T("Buttons:Button_Yes"),
                            cancelButtonText: T("Buttons:Button_No"),
                            confirmButtonColor: "#05CE78",
                            cancelButtonColor: "#596C7F",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        // IF USER CLICKS YES → retry with full app price range
                        if (result.isConfirmed) {
                            handleSearchTypeRef && handleSearchTypeRef("Popup");
                            dispatch(setPriceRangeValue({ low: AppConfig.minPrice, high: AppConfig.maxPrice }));
                        }
                    }

                    if (
                        response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code === "204.03" &&
                        response?.data?.responseType === 'Memory'
                    ) {
                        dispatch(setActivityIndicator(false));

                        await Swal.fire({
                            title: T("Common:Offers_Not_Found"),
                            text: response?.data?.warnings[0]?.description,
                            iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                            showCancelButton: false,
                            confirmButtonText: T("Buttons:Button_Ok"),
                            confirmButtonColor: "#05CE78",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    }

                    if (
                        response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code === "204.05" &&
                        response?.data?.responseType === 'RealTime'
                    ) {
                        dispatch(setActivityIndicator(false));
                        const result = await Swal.fire({
                            title: T("Common:Flights_Info"),
                            text: T("Common:Continue_With_Direct_Flights"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                            iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                            showCancelButton: true,
                            confirmButtonText: T("Buttons:Button_Yes"),
                            cancelButtonText: T("Buttons:Button_No"),
                            confirmButtonColor: "#05CE78",
                            cancelButtonColor: "#596C7F",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        // IF USER CLICKS NO → STOP EXECUTION
                        if (!result.isConfirmed) {
                            toast.info(T("Toasts:Toast_Flight_With_Stopover_Message"), {
                                onClose: () => {
                                    if (navigate) {
                                        navigate(-1); // Navigate back
                                    }
                                }
                            });
                            return {
                                cancelled: true,
                                offers: [],
                                correlationId: response?.data?.correlationId || params?.GUID,
                                totalOffersCount: 0,
                                params: params,
                                response: response,
                            };
                        }
                    }

                    if (
                        response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code === "204.02" &&
                        response?.data?.responseType === 'RealTime'
                    ) {
                        dispatch(setActivityIndicator(false));
                        dispatch(setStatusCodeByGuid({ guid: response?.data?.correlationId || params?.GUID, warnings: response?.data?.warnings }));
                    }

                    if (
                        response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code === "204.03" &&
                        response?.data?.responseType === 'RealTime'
                    ) {
                        dispatch(setActivityIndicator(false));
                        dispatch(setStatusCodeByGuid({ guid: response?.data?.correlationId || params?.GUID, warnings: response?.data?.warnings }));
                    }

                    if (response?.data?.responseType === 'RealTime' && shouldAddToSearchHistory) {
                        let airportCode = geniusDestinationObject?.airportCode && geniusDestinationObject.airportCode !== '001' ? geniusDestinationObject.airportCode : null;

                        // Create a deep copy of params to avoid immutability issues
                        let mutableParams = JSON.parse(JSON.stringify(params));

                        if (airportCode && mutableParams.FlightSegmentList && mutableParams.FlightSegmentList.length >= 2) {
                            // Replace in Arrival.CodeList of index 0
                            if (mutableParams.FlightSegmentList[0]?.Arrival?.CodeList?.length > 0) {
                                mutableParams.FlightSegmentList[0].Arrival.CodeList = [airportCode];
                            }
                            // Replace in Departure.CodeList of index 1
                            if (mutableParams.FlightSegmentList[1]?.Departure?.CodeList?.length > 0) {
                                mutableParams.FlightSegmentList[1].Departure.CodeList = [airportCode];
                            }

                            dispatch(setDesireCountry(geniusDestinationObject));
                        }

                        let lastSearchParams = {
                            ...mutableParams,
                            date: new Date(),
                            GUID: '',
                            id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
                        };

                        dispatch(setLastSearch(lastSearchParams));
                    }

                    return resolve({
                        offers: _offers,
                        correlationId: response?.data?.correlationId || params?.GUID,
                        totalOffersCount:
                            response?.data?.metaData?.offersAfterFilter ||
                            _offers?.length ||
                            0,
                        params: params,
                        response: response,
                        cancelled: false
                    });
                })
                .catch((error) => {
                    console.error(error);
                    if (error?.response?.data?.errors?.length) {
                        toast.error(error?.response?.data?.errors[0]?.description);
                    }
                    return reject(error);
                });
        });
    }
);

// export const getPackages = createAsyncThunk("hotels/getPackages", async () => {
//     const response = await get(API_HOME_PACKAGE_TYPES);
//     return response.data?.packageTypes;
// });

const initialState = {
    offers: [],
    offersContainer: [],
    // packageTypes: [],
    loadingScreen: false,
    favPkgs: [],
    selectedCurrency: "USD",
    pagination: null,
    correlationId: null,
    shouldRedirect: false,
    showRectangular: true,
    modals: { login: false, register: false, confirmation: false },
    responseType: null,
    error: null,
    // isPackageOffers: true,
    lowPrice: 0,
    highPrice: 2500,
    metaDataCount: 0,
    metaData: null,
    transaction_id: null,
    branchData: null,
    isChatGPTOffers: false,
    chatGPTOffers: [],
    metaDataCountByGuid: {},
    priceExceedOffersByGuid: {},
    statusCodeByGuid: {}
};

export const appconfigSlice = createSlice({
    name: "appconfig",
    initialState,
    reducers: {
        resetAppConfigState: () => initialState,
        setActivityIndicator: (state, action) => {
            state.loadingScreen = action.payload;
        },
        setOffers: (state, action) => {
            state.offers = action.payload;
        },
        // setPackageTypesState: (state, action) => {
        //     state.packageTypes = action.payload;
        // },
        removeOffer: (state, action) => {
            state.favPkgs = state.favPkgs.filter(
                (item) => item.id !== action.payload
            );
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        setShowRectangular: (state, action) => {
            state.showRectangular = action.payload;
        },
        setModals: (state, action) => {
            state.modals = action.payload;
        },
        setResponseType: (state, action) => {
            state.responseType = action.payload;
        },
        setTransactionId: (state, action) => {
            state.transaction_id = action.payload;
        },
        setBranchData: (state, action) => {
            state.branchData = action.payload;
        },
        setMetaDataCount: (state, action) => {
            state.metaDataCount = action.payload;
        },
        setMetaDataCountByGuid: (state, action) => {
            const { guid, count } = action.payload || {};
            if (!guid) {
                return;
            }
            state.metaDataCountByGuid[guid] = count ?? 0;
        },
        setPriceExceedOffersByGuid: (state, action) => {
            const { guid, status } = action.payload || {};
            if (!guid) {
                return;
            }
            state.priceExceedOffersByGuid[guid] = status ?? false;
        },
        setMetaData: (state, action) => {
            state.metaData = action.payload;
        },
        setIsChatGPTOffers: (state, action) => {
            state.isChatGPTOffers = action.payload;
        },
        setChatGPTOffers: (state, action) => {
            state.chatGPTOffers = [...state.chatGPTOffers, ...action.payload];
        },
        resetChatGPTOffers: (state) => {
            state.chatGPTOffers = [];
            state.metaDataCountByGuid = {};
        },
        setStatusCodeByGuid: (state, action) => {
            state.statusCodeByGuid = action.payload || {};
        },
        resetAppConfig: (state) => {
            state.offers = [];
            state.offersContainer = [];
            state.loadingScreen = false;
            state.favPkgs = [];
            state.pagination = null;
            state.correlationId = null;
            state.shouldRedirect = false;
            state.showRectangular = true;
            state.modals = { login: false, register: false, confirmation: false };
            state.responseType = null;
            state.error = null;
            state.metaDataCount = 0;
            state.metaData = null;
            state.isChatGPTOffers = false;
            state.chatGPTOffers = [];
            state.metaDataCountByGuid = {};
            state.priceExceedOffersByGuid = {};
            state.statusCodeByGuid = {};
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getHotels.pending, (state, action) => {
                if (action?.meta?.arg?.shouldLoading === false) {
                    return;
                }
                state.loadingScreen = true;
            })
            .addCase(getHotels.fulfilled, (state, action) => {
                let { offers, correlationId, totalOffersCount, params, response, cancelled } =
                    action.payload;

                // state.loadingScreen = false;
                state.loadingScreen = response?.data?.responseType === "RealTime" &&
                    offers.length > 0 &&
                    !(response?.data?.warnings?.length &&
                        response?.data?.warnings[0]?.code === "204.02");

                if (cancelled) {
                    state.loadingScreen = false;
                    state.offers = [];
                    state.offersContainer = [];
                    state.pagination = null;
                    state.metaDataCount = 0;
                    state.metaData = null;
                    return;
                }

                state.correlationId = correlationId;
                state.offers = offers;
                state.offersContainer = offers;
                state.pagination = getPager(totalOffersCount, params.Page, 10, window.innerWidth < 768 ? 5 : 10);

                // Saving responseType in state to handle the scenario when RealTime or Memory
                state.responseType = response?.data?.responseType;

                // Sort numerically and only over usable values: a bare .sort()
                // orders numbers as strings (90 > 1000), and `offers` can be
                // absent, which made the following lines throw.
                const arr = (offers ?? [])
                    .map((m) => Number(m?.perPersonPrice?.totalPrice))
                    .filter((n) => Number.isFinite(n))
                    .sort((a, b) => a - b);

                if (arr.length) {
                    state.lowPrice = arr[0];
                    state.highPrice = arr[arr.length - 1];
                }

                state.metaDataCount = response?.data?.metaData?.offersAfterFilter || 0;
                if (correlationId) {
                    state.metaDataCountByGuid[correlationId] = state.metaDataCount;
                }
            })
            .addCase(getHotels.rejected, (state) => {
                state.loadingScreen = false;
            })
    },
});

export const getAppConfig = (state) => state.appconfig;
const offersSelector = (state) => state.appconfig.offers;

// Memoized selector to get the cheapest offers
export const getCheapestOffers = createSelector(
    [offersSelector],
    (offers) => {
        return (
            offers
                ?.slice() // Create a shallow copy
                .sort((a, b) => a?.price?.totalPrice - b?.price?.totalPrice) // Sort by total price
                .slice(0, 4) || [] // Take the top 4 cheapest offers
        );
    }
);

// Action creators are generated for each case reducer function
export const {
    resetAppConfigState,
    // setPackageTypesState,
    setOffers,
    setActivityIndicator,
    removeOffer,
    setPagination,
    setShowRectangular,
    setModals,
    setResponseType,
    setTransactionId,
    setBranchData,
    setIsChatGPTOffers,
    setChatGPTOffers,
    setMetaDataCount,
    setMetaData,
    resetChatGPTOffers,
    setMetaDataCountByGuid,
    setPriceExceedOffersByGuid,
    setStatusCodeByGuid,
    resetAppConfig
} = appconfigSlice.actions;

export default appconfigSlice.reducer;
